import http from "@/http-common";

const get = async (token) => {
  return await http
    .get(`/staff/entrance-report`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const report = async (token, lastSync = undefined) => {
  return await http
    .get(`/staff/entrance-report/report`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        lastSync,
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
 get,
 report,
};
